import type { RefInfo } from '@wix/document-services-types'
import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import { DataWithDrafts, DraftDataItem } from './dataResolvingTypes'

export const removeHash = (id: string): string => {
	return id.startsWith('#') ? id.slice(1) : id
}

export const isDraftDataItem = (dataItem: DataWithDrafts): dataItem is DraftDataItem =>
	'_isDraftItem' in dataItem && dataItem._isDraftItem

const isWeakRef = (refInfo: RefInfo) => !refInfo.isRefOwner

export const resolveDataItem = (
	refInfo: RefInfo,
	refs: Record<string, BaseDataItem | undefined>,
	id: string
): string | BaseDataItem | undefined => {
	const cleanId = removeHash(id)
	if (!cleanId) {
		return undefined
	}
	return isWeakRef(refInfo) ? refs[cleanId] ?? cleanId : refs[cleanId]
}
